import { REGION_CITY_ROWS } from './regionsCatalog';
import { getCityNativeLabel } from './onboardingRegionLabels';

/** Bottom tabs, add-region, trade badges, regions.*, location.areas.* */
const TABS_BY_LANG = {
  ko: { home: '홈', trade: '거래', story: '밍고스토리', events: '이벤트', life: '생활정보', community: '커뮤니티', chat: '채팅', profile: '내정보' },
  en: { home: 'Home', trade: 'Trade', story: 'Mingo Story', events: 'Events', life: 'Local', community: 'Community', chat: 'Chat', profile: 'Profile' },
  vi: { home: 'Trang chủ', trade: 'Giao dịch', story: 'Truyện', services: 'Tìm kiếm & Dịch vụ', events: 'Sự kiện', life: 'Địa phương', community: 'Cộng đồng', chat: 'Trò chuyện', profile: 'Hồ sơ' },
  ru: { home: 'Главная', trade: 'Торговля', story: 'Истории', services: 'Поиск по услугам', events: 'События', life: 'Местное', community: 'Сообщество', chat: 'Чат', profile: 'Профиль' },
  ja: { home: 'ホーム', trade: '取引', story: 'Mingo Story', events: 'イベント', life: 'ローカル', community: 'コミュニティ', chat: 'チャット', profile: 'プロフィール' },
  'zh-CN': { home: '首页', trade: '交易', story: 'Mingo Story', events: '活动', life: '本地', community: '社区', chat: '聊天', profile: '个人' },
  'zh-TW': { home: '首頁', trade: '交易', story: 'Mingo Story', events: '活動', life: '本地', community: '社區', chat: '聊天', profile: '個人' },
  th: { home: 'หน้าแรก', trade: 'ซื้อขาย', story: 'Mingo Story', events: 'อีเวนต์', life: 'ท้องถิ่น', community: 'ชุมชน', chat: 'แชท', profile: 'โปรไฟล์' },
  id: { home: 'Beranda', trade: 'Jual-beli', story: 'Mingo Story', events: 'Acara', life: 'Lokal', community: 'Komunitas', chat: 'Obrolan', profile: 'Profil' },
  hi: { home: 'होम', trade: 'व्यापार', story: 'Mingo Story', events: 'इवेंट', life: 'स्थानीय', community: 'समुदाय', chat: 'चैट', profile: 'प्रोफ़ाइल' },
};

const ADD_REGION_BY_LANG = {
  ko: '지역 추가',
  en: 'Add Region',
  vi: 'Thêm khu vực',
  ru: 'Добавить регион',
  ja: '地域を追加',
  'zh-CN': '添加地区',
  'zh-TW': '新增地區',
  th: 'เพิ่มพื้นที่',
  id: 'Tambah wilayah',
  hi: 'क्षेत्र जोड़ें',
};

const TRADE_STATUS_BY_LANG = {
  ko: { selling: '판매중', reserved: '예약중', sold: '판매완료' },
  en: { selling: 'On Sale', reserved: 'Reserved', sold: 'Sold' },
  vi: { selling: 'Đang bán', reserved: 'Đã đặt', sold: 'Đã bán' },
  ru: { selling: 'В продаже', reserved: 'Забронировано', sold: 'Продано' },
  ja: { selling: '販売中', reserved: '予約中', sold: '売却済み' },
  'zh-CN': { selling: '出售中', reserved: '预约中', sold: '已售出' },
  'zh-TW': { selling: '出售中', reserved: '預約中', sold: '已售出' },
  th: { selling: 'กำลังขาย', reserved: 'จองแล้ว', sold: 'ขายแล้ว' },
  id: { selling: 'Dijual', reserved: 'Dipesan', sold: 'Terjual' },
  hi: { selling: 'बिक्री में', reserved: 'आरक्षित', sold: 'बिक चुका' },
};

const REGIONS_ALL_BY_LANG = {
  ko: '전 지역',
  en: 'All regions',
  vi: 'Toàn khu vực',
  ru: 'Все регионы',
  ja: '全地域',
  'zh-CN': '全部地区',
  'zh-TW': '全部地區',
  th: 'ทุกพื้นที่',
  id: 'Semua wilayah',
  hi: 'सभी क्षेत्र',
};

const AREAS_BY_LANG = {
  myKhe: {
    ko: '미케비치',
    en: 'My Khe',
    vi: 'Mỹ Khê',
    ru: 'Микхе',
    ja: 'ミーケー',
    'zh-CN': '美溪',
    'zh-TW': '美溪',
    th: 'หาดมิเค',
    id: 'My Khe',
    hi: 'माई खे',
  },
  hanRiver: {
    ko: '한강',
    en: 'Han River',
    vi: 'Sông Hàn',
    ru: 'Ханган',
    ja: '漢江',
    'zh-CN': '汉江',
    'zh-TW': '漢江',
    th: 'แม่น้ำฮัน',
    id: 'Sungai Han',
    hi: 'हान नदी',
  },
};

/** region_key → localized city label (extends catalog picks) */
const REGION_CITY_BY_LANG = {
  ja: {
    danang: 'ダナン',
    hochiminh: 'ホーチミン',
    hanoi: 'ハノイ',
    seoul: 'ソウル',
    busan: '釜山',
    tokyo: '東京',
    osaka: '大阪',
    bangkok: 'バンコック',
    shanghai: '上海',
    beijing: '北京',
    taipei: '台北',
    bali: 'バリ',
    singapore: 'シンガポール',
    manila: 'マニラ',
    moscow: 'モスクワ',
  },
  'zh-CN': {
    danang: '岘港',
    hochiminh: '胡志明市',
    hanoi: '河内',
    seoul: '首尔',
    busan: '釜山',
    tokyo: '东京',
    osaka: '大阪',
    bangkok: '曼谷',
    shanghai: '上海',
    beijing: '北京',
    taipei: '台北',
    bali: '巴厘岛',
    singapore: '新加坡',
    manila: '马尼拉',
    moscow: '莫斯科',
  },
  'zh-TW': {
    danang: '峴港',
    hochiminh: '胡志明市',
    hanoi: '河內',
    seoul: '首爾',
    busan: '釜山',
    tokyo: '東京',
    osaka: '大阪',
    bangkok: '曼谷',
    shanghai: '上海',
    beijing: '北京',
    taipei: '台北',
    bali: '峇里島',
    singapore: '新加坡',
    manila: '馬尼拉',
    moscow: '莫斯科',
  },
  th: {
    danang: 'ดานัง',
    hochiminh: 'โฮจิมินห์',
    hanoi: 'ฮานอย',
    seoul: 'โซล',
    busan: 'ปูซาน',
    tokyo: 'โตเกียว',
    bangkok: 'กรุงเทพฯ',
    bali: 'บาหลี',
  },
  id: {
    danang: 'Da Nang',
    hochiminh: 'Ho Chi Minh',
    hanoi: 'Hanoi',
    seoul: 'Seoul',
    busan: 'Busan',
    jakarta: 'Jakarta',
    bali: 'Bali',
  },
  hi: {
    danang: 'दा नांग',
    seoul: 'सियोल',
    busan: 'बुसान',
    tokyo: 'टोक्यो',
    bangkok: 'बैंकॉक',
  },
  ru: {
    danang: 'Дананг',
    hochiminh: 'Хошимин',
    hanoi: 'Ханой',
    seoul: 'Сеул',
    busan: 'Пусан',
    tokyo: 'Токио',
    osaka: 'Осака',
    bangkok: 'Бангкок',
    shanghai: 'Шанхай',
    beijing: 'Пекин',
    moscow: 'Москва',
    bali: 'Бали',
  },
  vi: {
    danang: 'Đà Nẵng',
    hochiminh: 'TP. Hồ Chí Minh',
    hanoi: 'Hà Nội',
    hoian: 'Hội An',
    seoul: 'Seoul',
    busan: 'Busan',
    tokyo: 'Tokyo',
    bangkok: 'Bangkok',
  },
};

function buildRegionsDict(lang) {
  const table = REGION_CITY_BY_LANG[lang] || {};
  const regions = { all: REGIONS_ALL_BY_LANG[lang] || REGIONS_ALL_BY_LANG.en };
  for (const row of REGION_CITY_ROWS) {
    if (table[row.key]) {
      regions[row.key] = table[row.key];
    } else if (lang === 'vi' && row.country === 'VN') {
      regions[row.key] = getCityNativeLabel(row) || row.pick;
    } else if (lang === 'ko') {
      regions[row.key] = row.ko;
    } else {
      regions[row.key] = row.pick;
    }
  }
  return regions;
}

function buildAreasDict(lang) {
  const areas = {};
  for (const [key, labels] of Object.entries(AREAS_BY_LANG)) {
    areas[key] = labels[lang] || labels.en;
  }
  return areas;
}

/**
 * @param {string} lang — resolveLocaleCode form
 * @returns {object} shallow tree for deepMerge into locale dict
 */
export function getShellUiOverlay(lang) {
  const code = lang in TABS_BY_LANG ? lang : 'en';
  return {
    tabs: TABS_BY_LANG[code] || TABS_BY_LANG.en,
    location: {
      addRegion: ADD_REGION_BY_LANG[code] || ADD_REGION_BY_LANG.en,
      areas: buildAreasDict(code),
    },
    trade: {
      ...(TRADE_STATUS_BY_LANG[code] || TRADE_STATUS_BY_LANG.en),
    },
    regions: buildRegionsDict(code),
  };
}

export default getShellUiOverlay;
